module.exports = __webpack_public_path__ + "static/media/ProreadrImg.b46b44bb.PNG";